import React from "react";
import { graphql } from "gatsby";
import { PrismicRichText, SliceZone } from "@prismicio/react";
import { isFilled } from "@prismicio/helpers";
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";

import Seo from "../components/meta/Seo";
import Layout from "../components/common/Layout";
import components from "../components/slices";
import MdsSection from "../components/utilities/MdsSection";

import "../styles/pages/simple-page.scss";

const SimplePage = ({ data, pageContext }) => {
  if (!data) return null;

  const { prismicSettings: settings, prismicSimplePage: page } = data;
  const { sliceData } = pageContext;

  return (
    <Layout settings={settings} page={page}>
      {isFilled.richText(page?.data?.content?.richText) && (
        <MdsSection>
          {page.data.title && (
            <h1 className="h3 py-12 text-center font-light">
              {page.data.title}
            </h1>
          )}
          <div className="flex flex-col gap">
            <PrismicRichText field={page.data.content.richText} />
          </div>
        </MdsSection>
      )}
      <div className="flex flex-col gap">
        <SliceZone
          slices={page?.data?.body}
          components={components}
          context={{ settings, page, ...sliceData }}
        />
      </div>
    </Layout>
  );
};

export default withPrismicPreview(SimplePage);

export const query = graphql`
  query simplePageQuery($lang: String, $id: String) {
    prismicSettings(lang: { eq: $lang }) {
      ...prismicSettingsFragment
    }
    prismicSimplePage(lang: { eq: $lang }, id: { eq: $id }) {
      ...prismicSimplePageFragment
    }
  }
`;

export const Head = ({ data }) => <Seo page={data.prismicSimplePage} />;
